/* unplugin-vue-components disabled */import { render } from "./bpmn-draw.vue?vue&type=template&id=55655f5a&scoped=true"
import script from "./bpmn-draw.vue?vue&type=script&lang=js"
export * from "./bpmn-draw.vue?vue&type=script&lang=js"

import "./bpmn-draw.vue?vue&type=style&index=0&id=55655f5a&scoped=true&lang=scss"
import "./bpmn-draw.vue?vue&type=style&index=1&id=55655f5a&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55655f5a"]])

export default __exports__